import { Component } from '@angular/core';

@Component({
  selector: 'app-msal-callback',
  template: '',
})
export class MsalCallbackComponent {}
